/* global document */

import AppContext from './context/AppContext';
import React, { useCallback, useContext, useMemo } from 'react';
import '../styles/ContactUsHeader.css';
import constants from '../constants.json' assert { type: 'json' };
import { GiMineTruck } from 'react-icons/gi';
import PropTypes from 'prop-types';
import { IoIosChatboxes } from 'react-icons/io';

const ContactUsHeader = ({
    showChat = true,
    showPhone = true,
    showChatIcon = false,
}) => {
    const { appContext } = useContext(AppContext);

    const phoneNumber = useMemo(
        () => appContext.config.contactPhoneNumber,
        [appContext.config.contactPhoneNumber],
    );

    const handleClick = useCallback(() => {
        const {
            FORM_IFRAME_ID,
            BUTTON_IFRAME_ID,
            INPUT_SELECTOR,
            TEXTAREA_SELECTOR,
            BUTTON_SELECTOR,
        } = constants.ZENDESK;

        const zendeskFormIframe = document.querySelector(FORM_IFRAME_ID);
        const zendeskButtonIframe = document.querySelector(BUTTON_IFRAME_ID);

        if (zendeskFormIframe) {
            const inputs = zendeskFormIframe.contentDocument.querySelectorAll(`${INPUT_SELECTOR}, ${TEXTAREA_SELECTOR}`);
            for (const input of inputs) {
                if (!input.value) {
                    input.focus();
                    break;
                }
            }
        } else if (zendeskButtonIframe) {
            const zendeskButton = zendeskButtonIframe.contentDocument.querySelector(BUTTON_SELECTOR);
            const messageInput = zendeskButtonIframe.contentDocument.querySelector(INPUT_SELECTOR);

            if (messageInput) {
                messageInput.focus();
            } else if (zendeskButton) {
                zendeskButton.click();
            }
        }
    }, []);

    return (
        <div
            className={'d-flex flex-column align-items-center justify-content-center'}>
            {showPhone && <div
                className={'contact-us-header'}>
                <h4
                    className={'m-0 p-0'}
                    style={{
                        whiteSpace: 'nowrap',
                        color: 'var(--primary-color)',
                        fontStyle: 'italic',
                    }}>
                    Call us Toll Free:
                </h4>
                <a
                    className={'custom-link'}
                    href={`tel:${phoneNumber}`}
                    style={{
                        fontStyle: 'italic',
                        fontWeight: '700',
                        whiteSpace: 'nowrap',
                        fontSize: '20px',
                    }}
                >
                    {phoneNumber}
                </a>
            </div>}
            {showChat && <div
                className={'text-center'}>
                <span
                    className={'fw-bold'}>
                    <GiMineTruck
                        size={28}
                    />   Parts for All Industrial Machines. Can&apos;t find your part? Click
                </span>
                <button
                    onClick={handleClick}
                    style={{
                        color: '#dc2a2a',
                        fontWeight: '700',
                        marginLeft: '5px',
                        textDecoration: 'none',
                    }}
                    className={'unstyled-btn'}
                >
                    Here
                </button>
            </div>}
            {showChatIcon && <button
                onClick={handleClick}
                className={'d-flex flex-column align-items-center justify-content-center py-2 unstyled-btn'}>
                <span
                >
                    <IoIosChatboxes
                        size={28}
                        color={'white'}
                    />
                </span>
                <span
                    style={{
                        color: 'white',
                        fontWeight: '700',
                        cursor: 'pointer',
                    }}
                >
                    CHAT NOW
                </span>
            </button>}
        </div>
    );
};

ContactUsHeader.propTypes = {
    showChat: PropTypes.bool,
    showPhone: PropTypes.bool,
    showChatIcon: PropTypes.bool,
};

export default ContactUsHeader;